// Components
import FaFacebook from '../icons/fa-facebook'
import FaInstagram from '../icons/fa-instagram'
import FaTwitter from '../icons/fa-twitter'
// Helpers
import {useEffect, useState} from 'react'
// Types
import type {CategoryAd} from '../../types/ballot'
// Styles
import styles from './question-ad-profile.module.scss'

interface QuestionAdProfileProps {
  ad: CategoryAd | null
  adPathTypeOverride?: 'desktop' | 'mobile' | null
}

const QuestionAdProfile = ({
  ad,
  adPathTypeOverride = null,
}: QuestionAdProfileProps) => {
  const [showButtonText, setShowButtonText] = useState(false)
  const [showDescription, setShowDescription] = useState(false)
  const [currentAdWidth, setCurrentAdWidth] = useState(300)

  const profileInfo = ad?.profile_card_additional_info

  // Adds resize handler
  useEffect(() => {
    const handleResize = () => {
      let newShowDescription = adPathTypeOverride === 'desktop'
      let newShowButtonText = adPathTypeOverride === 'desktop'
      let newCurrentAdImageWidth = 300

      if ((adPathTypeOverride !== 'desktop') && (adPathTypeOverride !== 'mobile')) {
        if (window.innerHeight >= 650) {
          newShowDescription = true
        }
        if (window.innerHeight >= 700) {
          newShowButtonText = true
        } else {
          // TODO: Test this for the 1px innerHeight issue @700px
          newCurrentAdImageWidth = (window.innerHeight - 100) / 2
        }
      }
      setShowDescription(newShowDescription)
      setShowButtonText(newShowButtonText)
      setCurrentAdWidth(newCurrentAdImageWidth)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return profileInfo
    ? <div
      className={`
          ${styles['question-ad-profile']}
          ${styles['--is-photo-voting']}
        `}
      style={{width: `${currentAdWidth}px`}}
    >
      <div className={styles['__content-container']}>
        <img
          src={profileInfo.image_path ?? undefined}
          alt={`${profileInfo && profileInfo.display_name} advertisement`}
          className={styles['__image']}
        />
        {profileInfo.display_name &&
          <div className={`subtitle is-4 ${styles['__content']} ${styles['--title']}`}>{profileInfo.display_name}</div>
        }
        <div className={`${styles['__content']} ${styles['--split']}`}>
          {profileInfo.address &&
            <div className={`subtitle is-4 ${styles['--address']}`}>{profileInfo.address}</div>
          }
          {profileInfo.phone_number &&
            <div className={`subtitle is-4 ${styles['--phone-number']}`}>{profileInfo.phone_number}</div>
          }
        </div>
        {profileInfo.business_summary && showDescription &&
          <div className={`subtitle is-4 ${styles['__content']} ${styles['--description']}`}>{profileInfo.business_summary}</div>
        }
        <div className={styles['__social-bar']} >
          {profileInfo.facebook_link &&
            <a
              href={profileInfo.facebook_link}
              target='_blank'
              className='button'
              style={{marginBottom: '0'}}
              rel="noreferrer"
            >
              <FaFacebook text='Facebook' showIconText={showButtonText} />
            </a>
          }
          {profileInfo.instagram_link &&
            <a
              href={profileInfo.instagram_link}
              target='_blank'
              className='button'
              style={{marginBottom: '0'}}
              rel="noreferrer"
            >
              <FaInstagram text='Instagram' showIconText={showButtonText} />
            </a>
          }
          {profileInfo.twitter_link &&
            <a
              href={profileInfo.twitter_link}
              target='_blank'
              className='button'
              style={{marginBottom: '0'}}
              rel="noreferrer"
            >
              <FaTwitter text='Twitter' showIconText={showButtonText} />
            </a>
          }
        </div>
      </div>
      <a
        href={ad?.website_link}
        target='_blank'
        className={styles['__whole-ad-link']}
        rel="noreferrer"
      >
      </a>
    </div>
    : null
}

export default QuestionAdProfile
